module.exports = __webpack_public_path__ + "img/Project1.3b35bebf.png";